import reclameAquiDesktop from '../../../../assets/images/banners/reclame-aqui/banner_reclame_aqui_desktop.png';
import reclameAquiTablet from '../../../../assets/images/banners/reclame-aqui/banner_reclame_aqui_tablet.png';
import reclameAquiMobile from '../../../../assets/images/banners/reclame-aqui/banner_reclame_aqui_mobile.png';

import { MarketingBannerContainer } from '../../atoms/MarketingBannerContainer';

interface IResponsiveMarketingBannersProps {
  className?: string;
}

type TBanner = {
  image: {
    desktop: string;
    tablet: string;
    mobile: string;
  };
  startDate: Date;
  endDate: Date;
  href: string;
  customValidation?: () => boolean;
};

function ResponsiveMarketingBanners({
  className,
}: IResponsiveMarketingBannersProps) {
  const banners: TBanner[] = [
    {
      image: {
        desktop: reclameAquiDesktop,
        tablet: reclameAquiTablet,
        mobile: reclameAquiMobile,
      },
      startDate: new Date('2024-10-27T00:00:00'),
      endDate: new Date('2024-10-31T23:59:59'),
      href: 'https://www.reclameaqui.com.br/premio/votacao/educacao/170/',
    },
  ];

  return (
    <>
      {banners.map((banner, index) => {
        const { image, startDate, endDate, href, customValidation } = banner;

        const now = new Date();
        if (now <= startDate || now >= endDate) {
          return <></>;
        }

        if (customValidation !== undefined && !customValidation()) {
          return <></>;
        }

        return (
          <MarketingBannerContainer
            key={index}
            className={className}
            bannerDesktop={image.desktop}
            bannerTablet={image.tablet}
            bannerMobile={image.mobile}
            link={href}
          />
        );
      })}
    </>
  );
}

export { ResponsiveMarketingBanners };
